import { render, staticRenderFns } from "./table-column.vue?vue&type=template&id=2b8f96a7&scoped=true"
import script from "./table-column.vue?vue&type=script&lang=js"
export * from "./table-column.vue?vue&type=script&lang=js"
import style0 from "./table-column.vue?vue&type=style&index=0&id=2b8f96a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8f96a7",
  null
  
)

export default component.exports